<template>
  <v-dialog v-model="internalValue" max-width="950px" persistent scrollable>
    <v-card class="rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center justify-space-between border-light-bottom bg-white">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">{{ isEditing ? 'mdi-pencil-outline' : 'mdi-calendar-plus' }}</v-icon>
          <span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
            {{ isEditing ? 'Editar Evento de Capacitación' : 'Nuevo Evento de Capacitación' }}
          </span>
        </div>
        <v-btn icon small @click="close">
          <v-icon color="grey darken-2">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-5 px-6">
        <v-row dense>
          <!-- Nombre del Evento y Tipo de Instrucción -->
          <v-col cols="12" md="8">
            <s-text v-model="form.TevName" label="Nombre del Evento *" :rules="[v => !!v || 'El nombre es obligatorio']" />
          </v-col>
          <v-col cols="12" md="4">
            <s-select-definition :def="1067" v-model="form.TypeInstruction" label="Tipo de Instrucción *" />
          </v-col>

          <!-- Descripción -->
          <v-col cols="12">
            <s-textarea v-model="form.TevDescription" label="Descripción del Evento" />
          </v-col>

          <!-- Fechas y Horas de Inicio y Fin -->
          <v-col cols="12" sm="6" md="3">
            <s-date v-model="dateStart" label="Fecha Inicio *" />
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <s-text type="time" v-model="timeStart" label="Hora Inicio *" />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <s-date v-model="dateEnd" label="Fecha Fin *" />
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <s-text type="time" v-model="timeEnd" label="Hora Fin *" />
          </v-col>

          <!-- Modalidad y Logística Dinámica (Sitio / Enlace) -->
          <v-col cols="12" sm="4">
            <s-select-definition :def="1459" v-model="form.TypeModality" label="Modalidad *" />
          </v-col>

          <!-- Si es Presencial o Híbrida: Sitio -->
          <v-col cols="12" sm="4" v-if="form.TypeModality === 1 || form.TypeModality === 3">
            <s-select-definition :def="1560" v-model="form.TevSite" label="Sitio / Sala de Capacitación" />
          </v-col>

          <!-- Si es Remota o Híbrida: Enlace de Reunión -->
          <v-col cols="12" :sm="form.TypeModality === 3 ? 4 : (form.TypeModality === 2 ? 8 : 4)" v-if="form.TypeModality === 2 || form.TypeModality === 3">
            <s-text v-model="form.TevLink" label="Enlace Virtual (Teams / Zoom / Meet)" placeholder="https://teams.microsoft.com/..." />
          </v-col>

          <!-- Campaña y Costos -->
          <v-col cols="12" sm="4">
            <s-select-campaign-se v-model="form.CmpID" label="Campaña *" />
          </v-col>
          <v-col cols="12" sm="4">
            <s-select-definition :def="1460" v-model="form.TypeCost" label="Tipo de Costo" />
          </v-col>
          <v-col cols="12" sm="4" v-if="form.TypeCost === 2">
            <s-text v-model.number="form.TevCostAmount" label="Monto de Costo (S/.)" decimal />
          </v-col>

          <!-- Difusión Móvil y Flyer Ari Sunshine -->
          <v-col cols="12" md="6" class="mt-2">
            <v-card class="pa-3 border-light rounded-lg" outlined elevation="0">
              <v-switch
                v-model="form.TevIsVisibleApp"
                :true-value="1"
                :false-value="0"
                color="primary"
                inset
                dense
                hide-details
                class="ma-0"
              >
                <template v-slot:label>
                  <span class="font-weight-bold grey--text text--darken-3">Visible en Ari Sunshine (Móvil)</span>
                </template>
              </v-switch>
              <div class="text-caption grey--text text--darken-1 mt-1">
                Publica automáticamente la convocatoria en la aplicación móvil de los colaboradores.
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" class="mt-2">
            <v-card class="pa-3 border-light rounded-lg d-flex align-center justify-space-between flex-wrap" outlined elevation="0">
              <div>
                <div class="font-weight-bold grey--text text--darken-3">Flyer Formato Celular (3:4)</div>
                <div class="text-caption grey--text text--darken-1 text-truncate" style="max-width: 250px;">
                  {{ form.TevFlyerPath ? form.TevFlyerPath : 'Sin flyer cargado (Recomendado 3:4)' }}
                </div>
              </div>
              <v-btn color="primary" outlined small class="rounded-lg text-none font-weight-bold" @click="openFlyerModal">
                <v-icon left small>mdi-cloud-upload</v-icon>
                {{ form.TevFlyerPath ? 'Cambiar Flyer' : 'Subir Flyer' }}
              </v-btn>
            </v-card>
          </v-col>

          <!-- Fecha y Hora Límite de Confirmación en App Móvil -->
          <v-col cols="12" sm="7" md="4" v-if="form.TevIsVisibleApp === 1">
            <s-date v-model="deadlineDate" label="Fecha Límite Confirmación App" />
          </v-col>
          <v-col cols="12" sm="5" md="2" v-if="form.TevIsVisibleApp === 1">
            <s-text type="time" v-model="deadlineTime" label="Hora Límite" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-3 px-6 justify-end bg-white">
        <v-btn text class="rounded-lg text-none font-weight-bold grey--text text--darken-3 px-4" @click="close">
          Cancelar
        </v-btn>
        <v-btn color="primary" class="rounded-lg text-none font-weight-bold px-6 white--text" elevation="0" :loading="saving" @click="save">
          <v-icon left small>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Modal de Flyer Móvil -->
    <TrainingEventFlyerModal
      v-model="flyerModal.show"
      :event-item="form"
      @flyerSelected="onFlyerSelected"
    />
  </v-dialog>
</template>

<script>
import SText from "@/components/Utils/SText.vue";
import SDate from "@/components/Utils/SDate.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import SSelectCampaignSe from "@/components/Utils/SSelectCampaignSe.vue";
import TrainingEventService from "@/services/Management/TrainingEventService";
import TrainingEventFlyerModal from "./TrainingEventFlyerModal.vue";

export default {
  name: "TrainingEventFormModal",
  components: {
    SText,
    SDate,
    SSelectDefinition,
    SSelectCampaignSe,
    TrainingEventFlyerModal,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saving: false,
      dateStart: this.$fun.getCurrentDate ? this.$fun.getCurrentDate() : new Date().toISOString().substr(0, 10),
      timeStart: "08:00",
      dateEnd: this.$fun.getCurrentDate ? this.$fun.getCurrentDate() : new Date().toISOString().substr(0, 10),
      timeEnd: "12:00",
      deadlineDate: null,
      deadlineTime: "23:59",
      form: {
        TevID: 0,
        TevName: "",
        TevDescription: "",
        TypeInstruction: 2, // Capacitación por defecto
        TypeModality: 1,    // Presencial por defecto
        TevSite: null,
        TevLink: "",
        TypeCost: 1,        // Sin Costo
        TevCostAmount: 0,
        CmpID: null,
        TevIsVisibleApp: 1,
        TevFlyerPath: null,
        TevConfirmationDeadline: null,
        TevStatus: 1,       // Programado
        SecStatus: 1,
      },
      flyerModal: {
        show: false,
      },
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isEditing() {
      return this.form.TevID > 0;
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editItem && this.editItem.TevID) {
          this.form = Object.assign({}, this.editItem);
          if (this.editItem.TevStartDateTime) {
            const startParts = this.editItem.TevStartDateTime.split("T");
            this.dateStart = startParts[0];
            if (startParts[1]) this.timeStart = startParts[1].substring(0, 5);
          }
          if (this.editItem.TevEndDateTime) {
            const endParts = this.editItem.TevEndDateTime.split("T");
            this.dateEnd = endParts[0];
            if (endParts[1]) this.timeEnd = endParts[1].substring(0, 5);
          }
          if (this.editItem.TevConfirmationDeadline) {
            const deadlineStr = String(this.editItem.TevConfirmationDeadline);
            const sep = deadlineStr.includes("T") ? "T" : " ";
            const deadParts = deadlineStr.split(sep);
            this.deadlineDate = deadParts[0];
            if (deadParts[1]) {
              this.deadlineTime = deadParts[1].substring(0, 5);
            } else {
              this.deadlineTime = "23:59";
            }
          } else {
            this.deadlineDate = null;
            this.deadlineTime = "23:59";
          }
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    resetForm() {
      const today = new Date().toISOString().substr(0, 10);
      this.dateStart = today;
      this.timeStart = "08:00";
      this.dateEnd = today;
      this.timeEnd = "12:00";
      this.deadlineDate = null;
      this.deadlineTime = "23:59";
      this.form = {
        TevID: 0,
        TevName: "",
        TevDescription: "",
        TypeInstruction: 2,
        TypeModality: 1,
        TevSite: null,
        TevLink: "",
        TypeCost: 1,
        TevCostAmount: 0,
        CmpID: null,
        TevIsVisibleApp: 1,
        TevFlyerPath: null,
        TevConfirmationDeadline: null,
        TevStatus: 1,
        SecStatus: 1,
      };
    },
    openFlyerModal() {
      this.flyerModal.show = true;
    },
    onFlyerSelected(filePath) {
      this.form.TevFlyerPath = filePath;
    },
    close() {
      this.internalValue = false;
    },
    save() {
      if (!this.form.TevName || !this.form.TevName.trim()) {
        this.$fun.alert("El nombre del evento es obligatorio.", "warning");
        return;
      }
      if (!this.form.TypeInstruction) {
        this.$fun.alert("Seleccione el tipo de instrucción.", "warning");
        return;
      }
      if (!this.form.CmpID) {
        this.$fun.alert("Seleccione la campaña del evento.", "warning");
        return;
      }
      if (!this.form.TypeModality) {
        this.$fun.alert("Seleccione la modalidad del evento.", "warning");
        return;
      }
      if ((this.form.TypeModality === 1 || this.form.TypeModality === 3) && !this.form.TevSite) {
        this.$fun.alert("Seleccione el sitio o sala para modalidad presencial/híbrida.", "warning");
        return;
      }
      if ((this.form.TypeModality === 2 || this.form.TypeModality === 3) && (!this.form.TevLink || !this.form.TevLink.trim())) {
        this.$fun.alert("Ingrese el enlace virtual (Teams / Meet / Zoom) para modalidad remota/híbrida.", "warning");
        return;
      }

      // Ensamblar DATETIME
      const startDateTime = `${this.dateStart}T${this.timeStart || '00:00'}:00`;
      const endDateTime = `${this.dateEnd}T${this.timeEnd || '23:59'}:00`;

      if (new Date(startDateTime) > new Date(endDateTime)) {
        this.$fun.alert("La fecha y hora de inicio no puede ser posterior a la fecha y hora de fin.", "warning");
        return;
      }

      let confirmationDeadline = null;
      if (this.form.TevIsVisibleApp === 1 && this.deadlineDate) {
        confirmationDeadline = `${this.deadlineDate}T${this.deadlineTime || '23:59'}:00`;
      }

      const payload = Object.assign({}, this.form, {
        TevStartDateTime: startDateTime,
        TevEndDateTime: endDateTime,
        TevConfirmationDeadline: confirmationDeadline,
      });

      this.$fun.alert("¿Está seguro de guardar el evento de capacitación?", "question").then((r) => {
        if (r && r.value) {
          this.saving = true;
          const reqId = this.$fun.getUserID();
          TrainingEventService.save(payload, reqId)
            .then(() => {
              this.$fun.alert("Evento guardado correctamente.", "success");
              this.$emit("saved");
              this.close();
            })
            .catch((err) => {
              this.$fun.alert(err?.response?.data?.Message || "Error al guardar el evento.", "error");
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
  },
};
</script>
